export default function ChatFooter() {
    return (
        <div
            className="bg-white border-t border-[#E5DFD3] px-4 pt-2 pb-2.5 text-center"
            data-testid="chatbot-footer"
        >
            <p className="text-[10.5px] text-[#6F6B63] leading-snug">
                <span className="font-[Outfit] font-semibold text-[#0E2A47]">Jerry</span>
                <span className="text-[#8F8B83]"> · Virtual Receptionist · Powered by AI</span>
                <br />
                Not a clinician — for clinical questions, please call{" "}
                <a
                    href="tel:+12815478447"
                    className="text-[#C8A24A] font-semibold hover:underline whitespace-nowrap"
                    data-testid="chatbot-footer-phone"
                >
                    281.547.8447
                </a>
            </p>
            <p className="text-[10px] text-[#8F8B83] mt-1.5 leading-snug">
                Do not share confidential or medical information. In an emergency call 911 or 988.
            </p>
        </div>
    );
}
